import React, { useEffect } from "react";

import "./popup.css";

function Popup({
  children = null,
  handleClosePopup: handleClosePopupCallback = null
}) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  function handlePopupClose(e) {
    if (e.target.className.match(/\bpopup\b/, "g")) {
      handleClosePopupCallback && handleClosePopupCallback();
    }
  }
  return (
    <div className="popup react-transition swipe-down" onClick={handlePopupClose}>
      {children}
    </div>
  );
}

export default Popup;
